import { Component, OnInit } from '@angular/core';
import { ApiHandlerService } from '../api-handler.service'
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  pocList = []

  constructor(private apiHandler: ApiHandlerService, private router: ActivatedRoute, private route: Router) { }

  ngOnInit() {
    this.getPOCList()
  }

  getToolsImage(tool, poc){
    let toolsDetail = poc.toolsDetail.find(x=>x.platformName == tool);
    if(toolsDetail){
      return toolsDetail.platformImage
    }else{
      return "https://omni-marketing-assets.s3.amazonaws.com/platforms/def_1.png"
    }
  }

  getPOCList(){
    this.apiHandler.getPOCList({}).subscribe(
      (result:any) => {
        this.pocList = result.data;
        console.log("POC",this.pocList)
    },
    err=>{
      
      
    }
    )
  }

  loadPOC(poc){ 
    this.route.navigate(['/library/'+poc.slug])
  }
}
